import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface MonitoringBatchState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allMonitoringBatch: [] | null | any;
}

const initialState: MonitoringBatchState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allMonitoringBatch: null,
};

export const monitoringBatchSlice = createSlice({
    name: 'MonitoringBatch',
    initialState,
    reducers: {
        setMonitoringBatch: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setMonitoringBatchBySearch: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setAllMonitoringBatch: (state, action) => {
            state.allMonitoringBatch = action.payload.data;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setMonitoringBatch, setMonitoringBatchBySearch, setAllMonitoringBatch, reset } = monitoringBatchSlice.actions;
export const getAllMonitoringBatchDetails = (state: RootState) => state.monitoringBatch.data;
export const getMonitoringBatchTotalRecords = (state: RootState) => state.monitoringBatch.totalRecords;
export const getAllMonitoringBatchBySearch = (state: RootState) => state.monitoringBatch.data;
export default monitoringBatchSlice.reducer;
